// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3TbfE","col":"styles_col__1OjvT","fulfillmentStatus":"styles_fulfillmentStatus__29ERD","emailCol":"styles_emailCol__2CzTf"};